/**
 * Created with IntelliJ IDEA.
 * User: omerh
 * Date: 6/3/13
 * Time: 6:04 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";
    var BaseModel = require("models/BaseModel");
    var _ = require("underscore");

    var NotifierModel = BaseModel.extend({
        defaults : {
            topPosition:"",
            notifierClass:"",
            notifierImageClass: "",
            module: "",
            type: "",
            textAction: "",
            message : "",
            textAdditionalButton: "",
            removeAditionalButton: false,
            removeMiddleButton:  true,  //default for middle button is hidden
            removePrimaryButton: false
        },
        initialize : function (options) {
            this.topPosition = options.topPosition || "15px";
            this.textAction = options.textAction || "";
            this.textAdditionalButton = options.textAdditionalButton || "";
            this.message = options.message || "";
            this.removePrimaryButton =   options.removePrimaryButton || false;
            this.removeMiddleButton = _.isUndefined(options.removeMiddleButton)?  true: options.removeMiddleButton;
            this.removeAditionalButton = options.removeAditionalButton || false;
        }
    });

    return NotifierModel;
});
